import React, { useState, useEffect } from 'react';
import {
  Card,
  Container,
  Row, Button, Spinner,
  FormGroup, Col, Input, Label, ModalFooter, Modal, ModalBody
} from "reactstrap";
import { Form, Field } from "react-final-form";
import dataProvider from "dataProvider";
import { NavLink as NavLinkRRD, Link, useHistory } from "react-router-dom";
import auth from "authProvider";
import Multiselect from 'multiselect-react-dropdown';

const TechnicianCreate = () => {
  const history = useHistory();
  const [category, setCategory] = useState([]);
  // const [category, setCategory] = useState(false);
  const [catresult, setCatresult] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = React.useState(false);
  const [catemptyOpen, setCatemptyopen] = useState(false);
  const [sucess, setSucess] = useState(false);

  const onLogout = () => {
    auth.logout();
    history.push("/")
  }

  useEffect(() => {
    dataProvider.getList('category', { params: { pagination: { page: 1, perPage: 20 }, sort: { order: 'desc', field: 'id' } }, filter: {} })
      .then(({ data }) => {
        setCategory(data)
        setCategory(data.map((cat, index) => ({ name: cat?.category, value: cat?.id })));
      })
      .catch(error => {
        if (error?.response?.data?.expire === true) {
          setModalOpen(true)
        }
      });

  }, []);

  const onSubmit = values => {
    if (catresult && catresult.length === 0) {
      setCatemptyopen(true)
      return;
    }

    setLoading(true)
    dataProvider.create('technicians', { params: { ...values, category: catresult } })
      // dataProvider.create('technicians', { params: { ...values, category: selectedOption } })
      .then(({ data }) => {
        setLoading(true)
        setSucess(true)
        setTimeout(() => Push(), 1000);
        // history.push("/technicians");
      })
      .catch(error => {
        setLoading(false)
        if (error?.response?.data?.expire === true) {
          setModalOpen(true)
        }
      });
  };
  const Push = () => {
    setSucess(false)
    history.push("/technicians");
  }
  const CategorySelect = (val) => {
    setCatresult(val.map((n) => n.value))
  }
  const CategoryRemove = (val) => {
    setCatresult(val.map((n) => n.value));
  }

  return (
    <>
      <div className="header pb-8 pt-5 pt-md-6" style={{
        width: '100%',
        backgroundImage:
          "url(" +
          require("../../../assets/img/brand/header.jpg").default +
          ")",
      }}>
        <Container fluid >
          <div className="header-body">
            {/* header*/}
            <Row style={{ color: 'white', fontSize: '1.25rem', paddingLeft: '20px', flexDirection: 'row', justifyContent: 'space-between' }}>
              <h1 className="mb-0" style={{ color: 'white', alignContent: 'flex-start' }}>CREATE TECHNICIAN</h1>
            </Row>
          </div>
        </Container>
      </div>
      {/* Page content */}
      <Container className="mt--7" fluid>
        {/* Table */}
        <Row>
          <div className="col">
            <Card className="shadow">
              <Row>
                <div className="col">
                  <Card className="shadow">
                    <Form
                      onSubmit={onSubmit}
                      validate={values => {
                        const errors = {};
                        function validateEmail(email) {
                          var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                          return re.test(String(email).toLowerCase());
                        }
                        function validatePhone(phone) {
                          var ph = /^(\d{8}(\,\d{8}){0,2})$/;
                          return ph.test(String(phone).toLowerCase());
                        }
                        if (!values.fullname) {
                          errors.fullname = "required";
                        }
                        if (!values.email) {
                          errors.email = "required";
                        } else if (!validateEmail(values.email)) {
                          errors.email = "Enter a valid email address";
                        }
                        if (!values.phone) {
                          errors.phone = "Required";
                        } else if (!validatePhone(values.phone)) {
                          errors.phone = "Enter a valid phonenumber";
                        }

                        return errors;
                      }}
                      render={({ handleSubmit }) => (
                        <form onSubmit={handleSubmit} style={{ padding: '20px' }}>
                          <div className="pl-lg-4">
                            <Row>
                              <Col lg="6">
                                <FormGroup>
                                  <Label style={{ fontSize: ' 0.8125rem' }} for="fullname">Full Name</Label>
                                  <Field name="fullname">
                                    {({ input, meta }) => (
                                      <div>
                                        <Input
                                          style={{ color: 'black' }}
                                          {...input}
                                          type="text"
                                          placeholder="Enter Technician Full Name"
                                          invalid={meta.error && meta.touched}
                                        />
                                        {meta.error && meta.touched && <span style={{ color: 'red', fontSize: '0.7rem' }}>{meta.error}</span>}
                                      </div>
                                    )}
                                  </Field>
                                </FormGroup>
                              </Col>
                              <Col lg="6">
                                <FormGroup>
                                  <Label style={{ fontSize: ' 0.8125rem' }} for="category">Category</Label>
                                  <Field name="category">
                                    {({ input, meta }) => (
                                      <div>
                                        <Multiselect
                                          showCheckbox={true}
                                          placeholder="Choose Category"
                                          options={category}
                                          displayValue="name"
                                          onSelect={(val) => CategorySelect(val)}
                                          onRemove={(val) => CategoryRemove(val)}
                                          showArrow={true}
                                          closeOnSelect={true}
                                        />
                                      </div>
                                    )}
                                  </Field>
                                </FormGroup>
                              </Col>
                            </Row>
                          </div>
                          <div className="pl-lg-4">
                            <Row>
                              <Col lg="6">
                                <FormGroup>
                                  <Label style={{ fontSize: ' 0.8125rem' }} for="email">E-Mail</Label>
                                  <Field name="email">
                                    {({ input, meta }) => (
                                      <div>
                                        <Input
                                          style={{ color: 'black' }}
                                          {...input}
                                          type="email"
                                          placeholder="Enter email address"
                                          invalid={meta.error && meta.touched}
                                        />
                                        {meta.error && meta.touched && <span style={{ color: 'red', fontSize: '0.7rem' }}>{meta.error}</span>}
                                      </div>
                                    )}
                                  </Field>
                                </FormGroup>
                              </Col>
                              <Col lg="6">
                                <FormGroup>
                                  <Label style={{ fontSize: ' 0.8125rem' }} for="phone">Phone Number</Label>
                                  <Field name="phone">
                                    {({ input, meta }) => (
                                      <div>
                                        <Input
                                          {...input}
                                          style={{ color: 'black' }}
                                          type="text"
                                          placeholder="Enter Phone Number"
                                          invalid={meta.error && meta.touched}
                                        />
                                        {meta.error && meta.touched && <span style={{ color: 'red', fontSize: '0.7rem' }}>{meta.error}</span>}
                                      </div>
                                    )}
                                  </Field>
                                </FormGroup>
                              </Col>
                            </Row>
                          </div>
                          <Col md="6">
                            <div style={{ paddingBottom: '30px', paddingRight: '30px' }}>
                              <Button disabled={loading} color={'white'} type="submit" style={{ backgroundColor: '#09577C', color: 'white', marginLeft: '10px', width: '80%', borderRadius: '10px', flex: 1, border: 0 }} >
                                {loading && (<Spinner as="span" size="sm" role="status" aria-hidden="true" style={{ marginRight: 20 }} />)}
                                SUBMIT</Button>{' '}
                            </div>
                          </Col>
                        </form>
                      )}
                    />
                  </Card>
                </div>
              </Row>
            </Card>
          </div>
        </Row>
      </Container>
      <Modal isOpen={sucess} size="sm">
        <ModalBody style={{ color: 'green' }}>Created successfully!</ModalBody>
      </Modal>
      <Modal isOpen={modalOpen} size="sm">
        <ModalBody style={{ backgroundColor: 'rgb(219 219 147)', color: 'white' }}>Your session has expired. Please sign in again.</ModalBody>
        <ModalFooter>
          <Button onClick={() => onLogout()} style={{ backgroundColor: '#09577C', color: 'white' }} type="button">
            LOGOUT
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={catemptyOpen} size="sm">
        <ModalBody style={{ backgroundColor: 'rgb(219 219 147)', color: 'red' }}>Please Fill Category Field</ModalBody>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Button onClick={() => setCatemptyopen(false)} style={{ backgroundColor: 'rgb(219 219 147)', color: 'red', width: 60, display: 'flex', justifyContent: 'center', border: '1px solid white', margin: 20 }} type="button">
            Ok
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default TechnicianCreate;